import { Logo } from "@/components/Logo/Logo";
import { Box, Theme, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export const OnboardingHeader = () => {
  const { t } = useTranslation("onboarding");

  return (
    <Box sx={{ marginBottom: "24px", width: "100%" }}>
      <Box component="div" sx={{ height: "52px" }}>
        <Logo width="171px" />
      </Box>
      <Typography variant="h1" fontSize={"1.5em"} textAlign={"center"} sx={{ margin: "16px 0px" }}>
        {t("label.title")}
      </Typography>
      <Typography
        textAlign={"center"}
        sx={{
          color: (theme: Theme) => theme.palette.text.secondary,
          fontSize: "0.875em"
        }}
      >
        {t("label.subtitle")}
      </Typography>
    </Box>
  );
};
